import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

const getBrandAmbassadorByID = async ({ ambassadorId, onlyPrimary = true }) => {
  const query = `query ($ambassadorId:ID! $onlyPrimary: Boolean) {
      brandAmbassador(ambassadorId:$ambassadorId){
        id
        firstName
        lastName
        status
        blockedReason
        dateOfBirth
        referralCode
        businessNumber
        insuranceNumber
        documentsProvided
        email
        fixedPriceMissions
        flyerCount
        isVerified
        itemCount
        memberSince
        mobilePhone
        profilePicture
        withholdPay
        isTeamLeader
        restrictedMissionType
        nationalRegistrationNumber
        role
        payrollProvider
        contractorType
        isNoticePeriod
        userWarning {
          count
        }
        paymentDetails {
          accountName
          accountNumber
          branchNumber
          bankAddress1
          bankAddress2
          bankCity
          bankPostCode
          bankCountry
          wiseId
          paymentVendor
        }
        city {
          id
          name
          teamLeaderEnabled
          timezone
          isBaDocumentManagementEnabled
          country{
            code
          }
          isBaDocumentManagementEnabled
        }
        formW9 {
          fileName
          fileSaveTime
        }
        signedLegalDocuments {
          totalCount
          edges {
            node {
              dateTime
              legalDocument {
                id
                url
                name
              }
            }
          }
        }
        rating
        emailVerificationLink
        missionsReviewedCountHandtohand
        missionsReviewedCountLetterbox
        documents(onlyPrimary: $onlyPrimary) {
          nodes {
              id
              url
              comment
              status
              createdAt
              updatedAt
              documentTypeId
              userId
              isPrimary
              rejectReason
              uploadedBy
              actorId
              uploader
              actor
          }
          count
        }
        paymentProviderData {
            userId
            initials
            gender
            birthdate
            nationality
            birthplace
            taxRebate
            comment
            rejectReason
            actorId
            status
            updatedAt
        }
        onSiteTrainingInfo {
          rating,
          comment,
          rated_by,
          date,
          user_who_rated_id
        }
        blockedInfo {
          created_at
          profile_user_id
          actioned_by_user_id
          user_who_updated
        }
        germanyContractData {
          id
          address
          postalCode
          contractType
          startDate
          hoursPerWeek
          createdAt
          updatedAt
          status
          comment
          actorId
          reSignedAt
          houseNumber
          exactAddress
          city
          state
          nationality
          preferredWorkDuration
          currentEmploymentStatus
          previousWork {
            companyName
            hoursPerDay
            contractType
            daysPerWeek
            startDate
            endDate
          }
        }
        germanyPayrollData {
          id
          taxId
          taxClass
          children
          socialSecurity
          religion
          middleName
          healthInsuranceType
          healthInsurance
          bankIban
          bankSwift
          birthCity
          birthCountry
          gender
          status
          comment
          actorId
          rejectReason
          updatedAt
        }
        category
        preScreening {
          workAuthorized
          availableDays
          area
          createdAt
        }
        userSettings {
          id
          baWeeklyMissionsLimit
          tlaWeeklyMissionsLimit
          createdAt
          updatedAt
        }
        germanyPaymentId
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    ambassadorId,
    onlyPrimary,
  })
}

const sendWarningGQL = ({ recipientId }) => {
  const mutation = `
    mutation sendWarning($recipientId: ID!){
      sendWarning(recipientId: $recipientId){
        success
        error
      }
    }
  `

  const variables = {
    recipientId,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const createUserProfileLog = async ({ input }) => {
  const mutation = `
  mutation createUserProfileLog($input: CreateUserProfileLogInput!){
    createUserProfileLog(input: $input)
  }`

  const variables = {
    input,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const getUserProfileLog = async ({ profile_user_id }) => {
  const sql = `
    query (
      $profile_user_id: ID!
    ){
      getUserProfileLog(
        profile_user_id: $profile_user_id
      ){
        profile_user_id,
        actioned_by_user_id,
        actioned_first_name,
        actioned_last_name
        type,
        created_at,
      }
    }`

  const params = {
    profile_user_id,
  }

  return callAuthorizedGraphQLEndpoint(sql, params)
}

const updateUserDocument = async ({ input }) => {
  const mutation = `
  mutation updateUserDocument($input: UpdateDocumentInput!){
    updateUserDocument(input: $input){
      success
    }
  }
  `

  const variables = {
    ...input,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const deleteUserDocument = async ({ input }) => {
  const mutation = `
  mutation deleteUserDocument($input: DeleteDocumentInput!){
    deleteUserDocument(input: $input){
      success
      }
    }
  `

  const variables = {
    input,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const refuseUser = async ({ input }) => {
  const mutation = `
  mutation refuseUser($input: RefuseUserInput!){
    refuseUser(input: $input){
      success
      }
    }
  `

  const variables = {
    input,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const createUserDocument = async ({ input }) => {
  const mutation = `
      mutation createUserDocument($input: CreateDocumentInput!){
        createUserDocument(input: $input){
          success
      }
    }
  `

  const variables = {
    input,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const updateNmbrsDocument = async ({ input }) => {
  const mutation = `
  mutation updatePaymentProviderData($input: UpdatePaymentProviderDataInput!){
    updatePaymentProviderData(input: $input){
      success
    }
  }
  `

  const variables = {
    input,
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const updateOnSiteTraining = async input => {
  const mutation = `
  mutation updateOnSiteTraining($input: UpdateOnSiteTrainingInput!){
    updateOnSiteTraining(input: $input)
  }  
  `
  const variables = {
    input,
  }
  return await callAuthorizedGraphQLEndpoint(mutation, variables)
}

const updateContractData = async input => {
  const mutation = `
  mutation updateGermanyContractData($input: UpdateGermanyContractDataInput!){
    updateGermanyContractData(input: $input){
      id
      userId
      contractType
      address
      postalCode
      startDate
      hoursPerWeek
      createdAt
      updatedAt
      status
      comment
      actorId
    }
  }
  `
  const variables = {
    input,
  }
  return await callAuthorizedGraphQLEndpoint(mutation, variables)
}

const readUserContract = async ({ userId, contractName }) => {
  return await callAuthorizedGraphQLEndpoint(
    `mutation readUserContract(
      $input: ReadUserContractInput!
    ) {
      readUserContract(
        input: $input
      ) { 
        url
        signedAt
        endAt
        status
        metadata
        createdAt
        templateDocument {
          name
        }
      }
    }`,
    {
      input: {
        userId,
        name: contractName,
      },
    },
  )
}
const readUserContractPreview = async ({ userId, name }) => {
  return await callAuthorizedGraphQLEndpoint(
    `mutation readUserContractPreview(
      $input: PreviewUserContractInput!
    ) {
      readUserContractPreview(
        input: $input
      ) { 
        url
        signedAt
        endAt
        createdAt
        templateDocument {
          name
        }
        metadata
      }
    }`,
    {
      input: {
        userId,
        name,
      },
    },
  )
}

const readAllUserContracts = async ({ userId }) => {
  const req = await callAuthorizedGraphQLEndpoint(
    `query readAllUserContracts($input: ReadAllUserContractsInput!) 
      {
        readAllUserContracts(input: $input) {
          id
          url
          metadata
          createdAt
          signedAt
          startAt
          endAt
          templateDocument {
            name
          }
          status
          addendum
        }
      }`,
    {
      input: {
        userId,
      },
    },
  )
  const res = await req.json()
  return res.data.readAllUserContracts
}

const readAllUserContractAddendum = async ({ contractId }) => {
  try {
    const req = await callAuthorizedGraphQLEndpoint(
      `query readAllUserContractAddendums($input: ReadAllUserContractAddendumsInput!) {
        readAllUserContractAddendums(input: $input) {
          id
          url
          metadata
          createdAt
          signedAt
          startAt
          endAt
          templateDocument {
            name
          }
          status
        }
    }`,
      {
        input: {
          contractId,
        },
      },
    )
    const res = await req.json()
    return res.data.readAllUserContractAddendums
  } catch (error) {
    return []
  }
}

const cancelContractAddendum = async id => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation cancelUserContractAddendum($input: CancelUserContractAddendumInput!) {
    cancelUserContractAddendum(input: $input) {
      success
    }
  }`,
    {
      input: {
        contractAddendumDraftId: id,
      },
    },
  )
  const res = await data.json()
  return res.data.cancelUserContractAddendum
}

const createUserContract = async ({
  userId,
  contractName,
  startAt,
  endAt,
  hoursPerWeek,
}) => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation createUserContract(
      $input: CreateUserContractInput!
    ) {
      createUserContract(
        input: $input
      ) { 
        url
      }
    }`,
    {
      input: {
        userId,
        name: contractName,
        startAt,
        endAt,
        hoursPerWeek,
      },
    },
  )
  return await data.json()
}

const createUserContractPDF = async ({
  userId,
  contractName,
  startAt,
  endAt,
  hoursPerWeek,
}) => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation createUserContractPDF(
      $input: CreateUserContractInput!
    ) {
      createUserContractPDF(
        input: $input
      ) { 
        url
      }
    }`,
    {
      input: {
        userId,
        name: contractName,
        startAt,
        endAt,
        hoursPerWeek,
      },
    },
  )
  return await data.json()
}

const createUserContractAddendum = async ({
  parentUserContractId,
  name,
  startAt,
  endAt,
  hoursPerWeek,
  file,
}) => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation createUserContractAddendum(
      $input: CreateUserContractAddendumInput!
    ) {
      createUserContractAddendum(
        input: $input
      ) { 
        url
      }
    }`,
    {
      input: {
        parentUserContractId,
        name,
        startAt,
        endAt,
        hoursPerWeek,
        file,
      },
    },
  )
  return await data.json()
}

const uploadUserContractAddendum = async ({
  parentUserContractId,
  name,
  startAt,
  endAt,
  workingHours,
  file,
}) => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation uploadUserContractAddendum(
      $input: CreateUserContractAddendumInput!
    ) {
      uploadUserContractAddendum(
        input: $input
      ) { 
        url
      }
    }`,
    {
      input: {
        parentUserContractId,
        name,
        startAt,
        endAt,
        workingHours,
        file,
      },
    },
  )
  const res = await data.json()
  return res.data.uploadUserContractAddendum
}

const cancelUserContract = async ({ userId, contractName }) => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation cancelUserContract(
      $input: CancelUserContractInput!
    ) {
      cancelUserContract(
        input: $input
      ) { 
        success
      }
    }`,
    {
      input: {
        userId,
        name: contractName,
      },
    },
  )
  return await data.json()
}

const updateUserContractEndDate = async ({ userId, endDate }) => {
  const data = await callAuthorizedGraphQLEndpoint(
    `mutation updateUserContractEndDate(
      $input: UpdateUserContractEndDateInput!
    ) {
      updateUserContractEndDate(
        input: $input
      ) { 
        success
        updatedType
        contractId
        addendumId
      }
    }`,
    {
      input: {
        userId,
        endDate,
      },
    },
  )
  return await data.json()
}

const updatePayrollData = async input => {
  const mutation = `
  mutation updateGermanyPayrollData($input: UpdateGermanyPayrollDataInput!){
    updateGermanyPayrollData(input: $input){
      id
      updatedAt
      status
      comment
      actorId
      rejectReason
    }
  }
  `
  const variables = {
    input,
  }
  return await callAuthorizedGraphQLEndpoint(mutation, variables)
}

const getDocumentAgreementContract = async ({ userId }) => {
  const query = `query documentAgreementContract($userId: ID!) {
    documentAgreementContract(userId: $userId) {
      url
      userId
      createdAt
      }
    }
    `
  const req = await callAuthorizedGraphQLEndpoint(query, { userId })

  const res = await req.json()
  return res.data.documentAgreementContract
}

const readNoShowMissionLog = async ({ userId, missionId }) => {
  return await callAuthorizedGraphQLEndpoint(
    `query readNoShowMissionLog($input: ReadNoShowMissionLogInput!) {
      readNoShowMissionLog(input: $input) {
        client 
        date
        city
        location
        mission
        campaign
        user
      }
    }`,
    {
      input: {
        userId,
        missionId,
      },
    },
  )
}

const getPayslipsByUserId = async ({ userId }) => {
  const query = `query ($ambassadorId: ID!) {
    brandAmbassador(ambassadorId: $ambassadorId) {
      payslips {
        edges {
          node {
            id
            year
            month
            fileUrl
            fileName
            uploadedByName
            createdAt
          }
        }
        totalCount
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, { ambassadorId: userId })
}

const deletePayslip = async ({ id }) => {
  const mutation = `
    mutation deletePayslip($id: ID!) {
      deletePayslip(id: $id) {
        success
      }
    }
  `

  return callAuthorizedGraphQLEndpoint(mutation, { id })
}

export {
  getBrandAmbassadorByID,
  sendWarningGQL,
  updateUserDocument,
  updateNmbrsDocument,
  deleteUserDocument,
  createUserDocument,
  refuseUser,
  createUserProfileLog,
  updateOnSiteTraining,
  updateContractData,
  readUserContract,
  createUserContract,
  readUserContractPreview,
  cancelUserContract,
  updatePayrollData,
  createUserContractPDF,
  createUserContractAddendum,
  readAllUserContracts,
  readAllUserContractAddendum,
  uploadUserContractAddendum,
  cancelContractAddendum,
  getDocumentAgreementContract,
  readNoShowMissionLog,
  updateUserContractEndDate,
  getPayslipsByUserId,
  deletePayslip,
}
